export var cssIssueOccurrence = 0;
export default function trackDisplayContentsOccurrence(element) {
  var computedStyle = window.getComputedStyle(element);
  if (computedStyle.display === 'contents') {
    cssIssueOccurrence++;
  }
}
export function resetCssIssueOccurrence() {
  cssIssueOccurrence = 0;
}